/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestRunParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['createdAt', parsers.moment, 'created_at'],
]);
export class AutoTestRun extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestRunParser.decode(input).map(res => new AutoTestRun(res));
    }
    static unsafeDecode(input) {
        return AutoTestRun.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestRunParser.encode(data);
    }
    static schema() {
        return AutoTestRunParser.schema();
    }
}
